// export const API="https://gomanee.com/";
// export const API="https://api.maneecafe.com/";

// export const APIMERTRADE="https://api.mertrades.com/";

export const API="https://apiroasters.maneearabicacoffee.com/";

// export const API="http://172.20.10.2:8000/";